// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2330":"07df181259fc5707","6622":"2351f6be5932bd0c"}[chunkId] + ".js";
};